import React from "react";
import * as s from "./DocumentsControl.styles";
import { useHistory, useLocation } from "react-router-dom";

// Image
import folderIcon from "../../../../../../assets/images/folder.png";

const DocumentsControl = (props) => {
  const { id, name } = props;
  const history = useHistory();
  const location = useLocation();
  return (
    <s.DocumentsContainer
      onClick={() => history.push(`${location.pathname}/folder/${id}/${name}`)}
    >
      <s.FolderIcon src={folderIcon} />
      <s.Span>{name}</s.Span>
    </s.DocumentsContainer>
  );
};

export default DocumentsControl;
